module.exports = __webpack_public_path__ + "static/media/ekomi_logo_animation.2395a3b1.gif";